import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionService } from './session.service';
import { environment } from 'src/environments/environment';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  constructor(private sessionService: SessionService,private helperService:HelperService) { }
  csrf_token;

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // let token = this.sessionService.token;
    // let id = this.sessionService.id;
    // //console.log(token, id)
    let authReq;
    this.csrf_token = this.helperService.csrf_token;
    this.csrf_token = this.csrf_token ? this.csrf_token : '';
    const bearerToken = httpRequest.headers.get("authorization");
    if (bearerToken) {
      let updatedHeaders = httpRequest.headers
        .set('Authorization', bearerToken)
        .set('X-CSRF-Token', this.csrf_token)
        .set('withCredentials', 'true')
        .set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache')
        .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
      const authReq = httpRequest.clone({ headers: updatedHeaders });
      return next.handle(authReq);
    }
     else if(!(httpRequest.url.toLocaleLowerCase().includes('image') || httpRequest.url.toLocaleLowerCase().includes('logo'))) {
      let updatedHeaders = httpRequest.headers
      .set('X-CSRF-Token', this.csrf_token)
      .set('withCredentials', 'true')
      authReq=httpRequest.clone({headers: updatedHeaders});
      return next.handle(authReq);
    }
    authReq=httpRequest;
    return next.handle(authReq);
  }
}
